/**
 * Unicode-safe base64 encoder (FT-443).
 *
 * `btoa()` throws `InvalidCharacterError` on any code point > 0xFF (curly
 * quotes, emoji, €, accented characters above Latin-1, etc). This wrapper
 * keeps the exact behaviour of `btoa()` for every input that `btoa()` already
 * handles (all ASCII AND all Latin-1 0x80-0xFF such as é, ñ, ü) — the output
 * is BYTE-IDENTICAL for those — and only falls back to the UTF-8 encoding
 * idiom for the inputs that currently crash.
 *
 * WHY the try/catch (and not the bare `btoa(unescape(encodeURIComponent(s)))`
 * idiom): the bare idiom UTF-8-encodes first, which changes the output for
 * Latin-1 characters (0x80-0xFF) that `btoa` already accepts — e.g. "café"
 * would produce a different string. Those values are currently written onto
 * records (equipment.shortCode) and could be displayed/stored/referenced, so
 * the fix must NOT alter any value that already works. The try/catch
 * guarantees identical output for every non-throwing input and only rescues
 * the throwing ones.
 *
 * @param {string} input - the string to base64-encode
 * @returns {string} base64 string
 */
export function safeBtoa(input) {
  const str = String(input);
  try {
    return btoa(str);
  } catch (e) {
    // Only reached when btoa() threw (code point > 0xFF). Encode as UTF-8
    // bytes first, then base64. Never changes output for inputs btoa accepts.
    return btoa(unescape(encodeURIComponent(str)));
  }
}
